import React from 'react';

export const Heading = ({ className, as: Element = 'h2', dark = false, children, ...props }) => {
  return (
    <Element
      {...props}
      className={`text-4xl font-medium tracking-tighter text-pretty text-gray-950 ${dark ? 'text-white' : ''} sm:text-6xl ${className || ''}`}
    >
      {children}
    </Element>
  );
};

export const Subheading = ({ className, as: Element = 'h2', dark = false, children, ...props }) => {
  return (
    <Element
      {...props}
      className={`font-mono text-xs/5 font-semibold tracking-widest text-gray-500 uppercase ${dark ? 'text-gray-400' : ''} ${className || ''}`}
    >
      {children}
    </Element>
  );
};

export const Lead = ({ className, children, ...props }) => {
  return (
    <p className={`text-2xl font-medium text-gray-500 ${className || ''}`} {...props}>
      {children}
    </p>
  );
};